import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { AboutBody } from '@/features/company-pages/components/AboutBody'
import { totalModelCount } from '@/features/home/data/homeContent'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'
import { getBreadcrumbSchema, renderJsonLd } from '@/lib/structured-data'

export const Route = createFileRoute('/about')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/about']),
    links: generateLinks(routeSEO['/about']),
    scripts: [
      {
        type: 'application/ld+json',
        children: renderJsonLd(
          getBreadcrumbSchema([
            { name: 'Home', url: '/' },
            { name: 'About', url: '/about' },
          ]) as any,
        ),
      },
    ],
  }),
  component: AboutPage,
})

function AboutPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Company"
          title="About"
          accent="ModelStack."
          lede={
            <>
              Every model behind one OpenAI-compatible endpoint. ModelStack is a
              unified API gateway that gives developers one key, one bill, and
              one integration for Claude, GPT, Gemini, and {totalModelCount}+
              other leading AI models — instead of juggling a separate account,
              key, and SDK for every provider.
            </>
          }
        />
        <AboutBody />
      </main>

      <Footer />
    </div>
  )
}
